$( document ).ready(function() {

  // Show more/less module
  function showMore() {
    const showBoxContent = $('.js-showBox-content');
    const showBoxFt = '.js-showBox-ft';
    const showBoxBtn = '.js-showBox-btn';
    const showBoxLess = '.js-showBox-less';
    const showBoxMore = '.js-showBox-more';
    const height = showBoxContent.outerHeight();
    
    if (height > 101){
      showBoxContent.addClass('active');
      $(showBoxFt).show();
    }
    
    $(showBoxBtn).click(function(e) {
      $(this).parent(showBoxFt).prev(showBoxContent).toggleClass('active');
      $(this).find(showBoxMore).toggleClass('active');
      $(this).find(showBoxLess).toggleClass('active');
  
      e.preventDefault();
    });
  };
  
  showMore();

  // Display Newsletter Popup on click
  function newsletterPopup() {
    const popup = '#newsletter_overlay';
    const activate = '.newsletter_button';
    const deactivate = '.newsletter_modal_close';
    
    $(activate).click(function(e) {
      $(this).parents('body').find(popup).addClass('active');
      e.preventDefault();
    });

    $(deactivate).click(function(e) {
      $(this).parents(popup).removeClass('active');
      e.preventDefault();
    });
  };
  
  newsletterPopup();
  
});